import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { DollarOutlined, CalendarOutlined } from '@ant-design/icons';
import BudgetsAllocation from './Allocation/Allocation';
import BudgetsCalendar from './Calendar/Calendar';

const { Title } = Typography;

const Budgets = () => {
  const [activeTab, setActiveTab] = useState('allocation');

  const items = [
    {
      key: 'allocation',
      label: (
        <span>
          <DollarOutlined /> Budget Allocation Tool
        </span>
      ),
      children: <BudgetsAllocation />
    },
    {
      key: 'calendar',
      label: (
        <span>
          <CalendarOutlined /> Multi-Client Calendar
        </span>
      ),
      children: <BudgetsCalendar />
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Budgets & Scheduling</Title>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
      />
    </div>
  );
};

export default Budgets;
